/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

const INDEXED_MESSAGE_MAX = 10;
const INDEXED_SURCHARGE_MAX = 10;
const INDEXED_LEGAL_MAX = 4;
const INDEXED_UDF_MAX = 10;

const scalarConnexUdmDeliveriesPathTokens = [
  'customData.orderDetails.orderedByPhone',
  'customData.CS.orderDetails.customerAccountType',
  'primaryLineItem.item.priceExtension.code',
  'origin.id',
  'destination.siteDistance.value',
  'destination.payDistance.value',
  'priceSummary.subtotalPrice',
  'priceSummary.taxAmount',
  'customData.CS.orderDetails.cod_order_amt',
  'customData.CS.resoldConcrete.actualBatchTime',
  'customData.CS.productDetails.wcContactDateTime',
  'origin.companyName',
  'customData.CS.receiptCode',
  'customData.CS.productDetails.strengthClass.id',
  'customData.CS.productDetails.strengthClass.name',
  'customData.CS.productDetails.cementTypeClass.printableField',
  'customData.CS.productDetails.cementTypeClass.class',
  'customData.CS.productDetails.cementTypeClass.subClass',
  'customData.CS.productDetails.cementTypeClass.replacementPercentage',
  'customData.CS.productDetails.coarseAggregateClass.id',
  'customData.CS.productDetails.addmixClass.name',
  'customData.CS.productDetails.batchBookType.name',
  'customData.CS.productDetails.consistenceClass.id',
  'customData.CS.productDetails.consistenceClass.nameOther',
  'customData.CS.productDetails.consistenceClass.nominalWorkability',
  'customData.CS.productDetails.minimumCementContent',
  'customData.CS.productDetails.maximumWaterCementRatio',
  'customData.CS.productDetails.dcClass.id',
  'customData.CS.productDetails.chlorideClass.id',
  'customData.CS.productDetails.chlorideClass.name',
  'customData.CS.productDetails.maximumAggSize',
  'customData.CS.productDetails.pValue',
  'customData.CS.exposureClass',
  'customData.CS.productDetails.lifetime',
  'customData.CS.orderDetails.resalePONumber',
  'customData.CS.productDetails.daysToStrength',
  'customData.CS.orderDetails.orderedTruckType',
  'concreteConstituents',
  'admixConstituents',
];

const expandIndexedPaths = () => {
  const paths = [];

  for (let i = 0; i <= INDEXED_MESSAGE_MAX; i++) {
    paths.push(`customData.CS.messageText.${i}`);
  }

  for (let i = 0; i <= INDEXED_SURCHARGE_MAX; i++) {
    paths.push(`customData.CS.charges.surcharge.${i}.id`);
  }

  for (let i = 0; i <= INDEXED_LEGAL_MAX; i++) {
    paths.push(`customData.CS.legalText.${i}`);
  }

  const udfSources = ['plant', 'order', 'ticket'];

  for (const src of udfSources) {
    for (let j = 0; j <= INDEXED_UDF_MAX; j++) {
      paths.push(`customData.CS.userDefined.${src}.${j}.field`);
      paths.push(`customData.CS.userDefined.${src}.${j}.value`);
      paths.push(`customData.CS.userDefined.${src}.${j}.index`);
    }
  }

  return paths;
};

export const CONNEX_UDM_DELIVERIES_PATH_TOKENS = [...scalarConnexUdmDeliveriesPathTokens, ...expandIndexedPaths()];
